export default __webpack_public_path__ + "static/media/border-bg-xm.ee138768.png";